<template>
  <div class="badge-container">
    {{ badge }}
  </div>
</template>
<style lang="scss" scoped src="./student-badge.scss"></style>
<script lang="ts" src="./student-badge.ts"></script>
